import { render, staticRenderFns } from "./select-input-order.vue?vue&type=template&id=b28a3b2c&"
import script from "./select-input-order.vue?vue&type=script&lang=js&"
export * from "./select-input-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports